import type { RoundRankView } from "@screener/protocol";
import { cn } from "@screener/uikit/lib/utils";
import { roundRankLabel } from "./format";

/**
 * Пометка круглой цены §2 — часть экрана, не UIKit, по той же проверке,
 * что `SideBadge`: её ранг есть сетка §2 и ничего больше, а решение «какому
 * рангу какая форма» — доменное ровно так же, как «какому рангу какая
 * подпись» (review stage5-round-price, п. 7). В UIKit она смотрелась бы
 * структурным дублем `RoundRankView` с картой глифов, объяснимой только
 * спецификацией, которой UIKit не знает.
 *
 * Цвет носителем смысла не является: три ранга различаются формой, а
 * `text-muted-foreground` — токен темы. Вариантов оформления нет, поэтому
 * нет и `cva`: ранг меняет глиф, а не классы.
 *
 * `title` не ставится: при `role="img"` с `aria-label` он превращается
 * в описание, и читалка произносит одну и ту же фразу дважды, а при
 * наведении перекрывает подсказку строки. Развёрнутую фразу про кратность
 * несёт `rowTitle`.
 */

/**
 * Три формы, а не три заливки одного круга: при кегле в 10 пикселей и
 * приглушённом цвете круг закрашенный и круг закрашенный наполовину
 * неразличимы на глаз, и различение сводилось бы к наведению мыши
 * (review stage5-round-price, п. 10). Символы — из базового геометрического
 * блока U+25xx, он есть в любом шрифте, которым эта таблица может собраться.
 */
export const ROUND_MARK_GLYPHS: Record<RoundRankView, string> = {
  whole: "●",
  half: "◆",
  fine: "○",
};

interface RoundMarkProps {
  rank: RoundRankView;
  className?: string;
}

export function RoundMark({ rank, className }: RoundMarkProps) {
  return (
    <span
      data-slot="round-mark"
      role="img"
      aria-label={roundRankLabel(rank)}
      data-round-rank={rank}
      className={cn("text-muted-foreground", className)}
    >
      {ROUND_MARK_GLYPHS[rank]}
    </span>
  );
}
